class FaqElement extends HTMLElement {
  /** @type {NodeListOf<HTMLElement>} */ #controllers = this.querySelectorAll('nav [aria-controls]');
  /** @type {NodeListOf<HTMLElement>} */ #targets = this.querySelectorAll('collapsible-element');
  /** @type {HTMLElement} */ #nav = this.querySelector('[data-faq-nav]');

  connectedCallback() {
    this.#controllers.forEach((controller) => {
      controller.addEventListener('click', () => this.#handleClick(controller));
    });
  }

  #handleClick(controller) {
    const isActive = controller.getAttribute('aria-expanded') === 'true';

    // Mobile: if clicking the active button, toggle dropdown open/closed
    if (isActive) {
      this.#nav.toggleAttribute('data-open');
      return;
    }

    // Close dropdown
    this.#nav.removeAttribute('data-open');

    const id = controller.getAttribute('aria-controls');

    this.#controllers.forEach((btn) => {
      btn.setAttribute('aria-expanded', btn === controller ? 'true' : 'false');
    });

    this.#targets.forEach((target) => {
      const isMatch = target.getAttribute('data-category-parent') === id;
      target.setAttribute('aria-hidden', isMatch ? 'false' : 'true');
    });
  }
}
customElements.define('faq-element', FaqElement);
